<template>
  <div class="statement mb" :style="bgc">
    <div class="statement__text-container gutter-lg">
      <slot name="title"></slot>
      <slot name="paragraph"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Statement',
  props: ['bg'],
  data () {
    return {
      bgc: {
        backgroundColor: this.bg
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .statement {
    background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.07));
    font-family: $fCaslon;
    color: $cWhite;
    padding: 60px 0 64px 0;
    display: flex;
    justify-content: center;
    &__text-container {
      // max-width: 640px;
    }
    h2 {
      font-size: 24px;
      line-height: 32px;
      font-weight: $fRegular;
      margin-bottom: 26px;
    }
    p {
      font-size: 24px;
      line-height: 32px;
      font-weight: $fBold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Statement.vue